import {
  APPLY_ERROR_SUPPLIER_PRIORITIZED,
  APPLY_PRIORIZED_BUYER,
  CLEAR_MSG_ORDER_PRIORIZED,
  CLOSE_DIALOG_WARNING_HABILITY_PARTICIPATE,
  GET_PRIORITIZED_SUPPLIER_ERROR,
  GET_PRIORITIZED_SUPPLIER_SUCCESS,
  GET_QUOTE_SEARCH_ERROR,
  GET_QUOTE_SEARCH_SUCCESS,
  GET_QUOTE_SEARCH,
  GET_SELLER_NOTIFICATION_SUCCESS,
  GET_SUPPLIER_HABILITY_V1_ERROR,
  GET_SUPPLIER_HABILITY_V1_SUCCESS,
  GET_SUPPLIER_HABILITY_V1,
  GET_SUPPLIER_HABILITY_V3_ERROR,
  GET_SUPPLIER_HABILITY_V3_SUCCESS,
  GET_SUPPLIER_HABILITY_V3,
  LOADING,
  MSG_ORDER_PRIORIZED,
  OPEN_DIALOG_WARNING_HABILITY_PARTICIPATE,
  SET_FORCE_PRIORIZED_ALREADY
} from './QuoteSearchHeadingFilters.actions'

const quoteSearchHeadingFiltersState = {
  cancellationDays: 0,
  error: undefined,
  forcePriorizedAlready: true,
  loading: false,
  msgOrderPrioritized: [],
  notifications: 0,
  openWarningHability: false,
  searchResult: {
    page: 1,
    pageCount: 0,
    pageSize: 0,
    resultCount: undefined,
    results: []
  },
  showDisclaimer: false,
  supplierHability: null,
  supplierPrioritized: null
}

/**
 * The quote search heading filters's reducer.
 */
const quoteSearchHeadingFiltersReducer = (state = quoteSearchHeadingFiltersState, { payload, type }) => {
  switch (type) {
    case GET_SUPPLIER_HABILITY_V1:
    case GET_SUPPLIER_HABILITY_V3:
    case GET_QUOTE_SEARCH: {
      return { ...state, loading: true }
    }
    case LOADING: {
      return { ...state, loading: false }
    }
    case GET_QUOTE_SEARCH_ERROR: {
      return {
        ...state,
        error: payload.error,
        loading: false,
        searchResult: {
          age: 1,
          pageCount: 0,
          pageSize: 0,
          resultCount: undefined,
          results: []
        }
      }
    }
    case GET_QUOTE_SEARCH_SUCCESS: {
      return {
        ...state,
        loading: false,
        error: undefined,
        searchResult: {
          ...state.searchResult,
          page: payload.page,
          pageCount: payload.pageCount,
          pageSize: payload.pageSize,
          resultCount: payload.resultCount,
          prioritized: payload.prioritized,
          results: payload.results
        }
      }
    }
    case CLOSE_DIALOG_WARNING_HABILITY_PARTICIPATE: {
      return { ...state, openWarningHability: false }
    }
    case OPEN_DIALOG_WARNING_HABILITY_PARTICIPATE: {
      return { ...state, openWarningHability: true }
    }
    case MSG_ORDER_PRIORIZED: {
      return { ...state, msgOrderPrioritized: [{ code: '201', description: 'participar_cotizaciones' }] }
    }
    case CLEAR_MSG_ORDER_PRIORIZED: {
      return { ...state, msgOrderPrioritized: [] }
    }
    case GET_SELLER_NOTIFICATION_SUCCESS: {
      return {
        ...state,
        notifications: payload.countRequests,
        cancellationDays: payload.cancellationDays,
        showDisclaimer: payload.showDisclaimer
      }
    }
    case GET_SUPPLIER_HABILITY_V1_ERROR:
    case GET_SUPPLIER_HABILITY_V3_ERROR:
    case GET_PRIORITIZED_SUPPLIER_ERROR: {
      return { ...state, loading: false, error: payload.error, supplierPrioritized: null }
    }
    case GET_SUPPLIER_HABILITY_V3_SUCCESS:
    case GET_SUPPLIER_HABILITY_V1_SUCCESS: {
      return { ...state, loading: false, error: undefined, supplierHability: { ...payload } }
    }
    case GET_PRIORITIZED_SUPPLIER_SUCCESS: {
      const { forzado = false, idMotivoForzado = null } = payload || {}
      return {
        ...state,
        loading: false,
        supplierPrioritized: {
          messages: [
            {
              code: '200-1',
              description: 'proveedor_priorizado_001'
            }
          ],
          isNoEMT: false,
          isForced: forzado,
          idForced: idMotivoForzado
        }
      }
    }
    case APPLY_ERROR_SUPPLIER_PRIORITIZED: {
      const { forzado = false, idMotivoForzado = null } = payload || {}
      return {
        ...state,
        supplierPrioritized: {
          errors: [{ code: '400', description: 'proveedor_no_habilitado_001' }],
          isNoEMT: true,
          isForced: forzado,
          idForced: idMotivoForzado
        }
      }
    }
    case APPLY_PRIORIZED_BUYER: {
      return {
        ...state,
        supplierPrioritized: {
          messages: [],
          errors: [],
          isNoEMT: false
        }
      }
    }
    case SET_FORCE_PRIORIZED_ALREADY: {
      return {
        ...state,
        forcePriorizedAlready: false
      }
    }
    default: {
      return state
    }
  }
}

export default quoteSearchHeadingFiltersReducer
